import {
  observable,
  reaction,
  computed,
  action,
  runInAction,
  autorun
} from "mobx"
import { Step, BookingFlow } from "../../BookingFlow"
import { debounce } from "../../../light/utils"
import { BookingDB } from "../../db/BookingLightDB"
import { Member } from "BookingSystem/db/Member"

export class GeneralStep implements Step {
  constructor() {
    const debouncedPhoneLookup = debounce(() => {
      const lookupText = this.phone && this.phone.replace(/\D/g, "").trim()
      this.search(lookupText)
    }, 200)

    reaction(() => this.phone, debouncedPhoneLookup)
  }

  @computed
  get userIsLoggedIn() {
    return this.db && this.flow.userIsLoggedIn
  }

  advanceOnUserLogin = autorun(() => {
    if (this.userIsLoggedIn) return this.flow.advance()
  })

  @observable
  flow: BookingFlow

  @observable
  db: BookingDB

  async search(lookupText: string) {
    this.foundMember = await this.flow.lookupMember(lookupText)
    if (this.foundMember) {
      if (this.foundMember.isValid) {
        const foundMember = this.foundMember
        runInAction(() => {
          this.flow.currentBooking.setMemberOwner(foundMember)
          this.flow.currentBooking.addMember(foundMember)
          if (foundMember.minors)
            foundMember.minors.forEach(this.flow.currentBooking.addMember)
        })
      } else {
        this.editMember(this.foundMember)
      }
    }
  }

  @action.bound
  editMember(member: Member) {
    this.flow.editMember(member, () => {
      runInAction(async () => {
        if (member.isValid) {
          try {
            this.db.save(member)
            await this.db.postNextSyncRequest()
            runInAction(() => {
              this.flow.currentBooking.addMember(member)
              this.flow.currentBooking.setMemberOwner(member)
            })
          } catch (err) {
            this.editMember(member)
          }
        } else {
          this.editMember(member)
        }
      })
    })
  }

  @action.bound
  editNewMember(phoneNum: string) {
    let newMember: Member = new Member(this.db)
    newMember.object.phone = phoneNum
    this.editMember(newMember)
  }

  @observable
  isCustomerExisting: boolean

  @action.bound
  isReturnCustomer() {
    this.isCustomerExisting = true
  }

  @observable
  name = "General"

  @observable
  phone: string

  @observable
  dateAttending = new Date()

  @observable
  foundMember?: Member

  @observable
  instruction?: string = "Please enter your phone number"

  @observable
  help?: string = "Not in our system?  Click I'm new"
}
